import i18n from "i18n";

export const SHOW_ALL_OPTION = {
	id: "",
	get name() {
		return i18n.t("label.showAll");
	},
}; 